import React from 'react';
import { componentTypes, RadixUIRangeSlider } from '@white-nl/instantsearch-components';

import Panel from '../ui/Panel';

export default function RangeSlider({
  results,
  slider,
  sliderSettings,
  additionalData,
}: componentTypes.RangeSliderPanelProps) {
  const { canRefine } = slider;
  const { attribute, panelSettings } = sliderSettings;
  const header = `${panelSettings?.header ?? attribute}`;

  if (!canRefine) {
    return null;
  }

  return (
    <Panel header={header}>
      <div className="flex flex-col gap-y-3 pt-1">
        <RadixUIRangeSlider
          results={results}
          slider={slider}
          sliderSettings={sliderSettings}
          additionalData={additionalData}
        />
      </div>
    </Panel>
  );
}
